exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-return[data-v-7e1ae91c]{position:absolute;top:105px;left:-65px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(2px 2px 2px #222);filter:drop-shadow(2px 2px 2px #222)}.button-return.disabled[data-v-7e1ae91c]{display:none;pointer-events:none;cursor:default}.button-title[data-v-7e1ae91c]{font-family:Nunito,sans-serif;position:absolute;bottom:12px;left:100px;z-index:999;font-size:14px;text-decoration:none;color:#fff;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7e1ae91c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonReturn.vue
// module id = 87
// module chunks = 0